import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { HouseHomeLogo } from "./AriakeLogo";

const NAV = [
  { href: "#nosotros", label: "Nosotros" },
  { href: "#proyectos", label: "Proyectos" },
  { href: "#ariake", label: "Ariake" },
  { href: "#historial", label: "Trayectoria" },
  { href: "#contacto", label: "Contacto" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/75 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="container-hh flex items-center justify-between py-3 md:py-4">
        <a
          href="#top"
          className="flex items-center gap-3 sm:gap-4 text-white"
          data-testid="nav-logo-link"
          aria-label="Inicio · Inmobiliaria House & Home"
        >
          <HouseHomeLogo variant="white" className="h-10 md:h-12 shrink-0" />
          <span className="hidden sm:flex flex-col leading-none border-l border-white/25 pl-3 sm:pl-4">
            <span className="overline text-white/55" style={{ fontSize: "0.55rem" }}>
              Inmobiliaria
            </span>
            <span
              className="font-display text-xl md:text-2xl mt-1 tracking-tight"
              style={{ fontStyle: "italic" }}
            >
              House&amp;Home
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-[0.78rem] tracking-[0.18em] uppercase text-white/70 hover:text-white transition-colors"
              data-testid={`nav-link-${item.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a href="#contacto" className="btn-hh btn-hh-ghost" data-testid="nav-cta-contact">
            Contacto
          </a>
        </div>

        <button
          aria-label="Abrir menú"
          className="lg:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-black border-t border-white/10" data-testid="nav-mobile-menu">
          <div className="container-hh py-6 flex flex-col gap-3">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="text-white/85 text-sm tracking-[0.2em] uppercase py-2 border-b border-white/10"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contacto"
              onClick={() => setOpen(false)}
              className="btn-hh btn-hh-ghost mt-2 text-center"
            >
              Solicitar asesoría
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
